import React from 'react'
import './collections_sub.css'
import Footer from '../../Home/Home_modules/Footerr/Footer_main'
import topbanner from './Im/sivajiban.png'
import topimg from './Im/topimg.png'
import sharebtn from './Im/sharebtn2.png'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Top_selling_cards from '../../Home/Home_modules/Top_selling_cards';


function Collections_sub() {
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
          partialVisibilityGutter: 30
        }
      };
    return (
        <div>
            <div className="collections-sub-top">
                <img src={topbanner} />
            </div>
            <div className="collections-sub-top2">
                <img src={topimg} />
                <h1>Shivaji: The boss</h1>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                <div className="collections-sub-topbtns">
                <button className="collections-sub-sharebtn"><i className="fas fa-share"></i></button><button className="collections-sub-sharebtn"><i className="fas fa-ellipsis-h"></i></button>
                </div>
            </div>
            <div className="explore">
             
           <div className="collection-explore-d">
           <Top_selling_cards />
</div>




{/* ---- Carousel Mobile  ---*/}
           <div className="collection-explore-m">
           <Carousel
           partialVisible={true} 
           responsive={responsive}
           autoPlay={true}
           autoPlaySpeed={3000}
           infinite={true}
           >
    <div className="explore-card">
    <button className="lo"></button>
    <button className="lo"></button>
    <button className="lo"></button>
    <div className="top-dot-menu">
        <button className="top-dot"></button>
        <button className="top-dot"></button>
        <button className="top-dot"></button>
    </div>


    <div className="top-im">

        {/* <img className="" src={} alt="Logo" /> */}



    </div>
    <div className="top-details">
        <p className="top-card-title">shivaji</p>
        <p className="top-card-title1">legendary</p>
        <p className="top-card-title-price">$ 230  </p>

    </div>
    <div className="like">
        <span className="glyphicon glyphicon-heart-empty"> </span>
    </div>

</div>

<div className="explore-card">
    <button className="lo"></button>
    <button className="lo"></button>
    <button className="lo"></button>
    <div className="top-dot-menu">
        <button className="top-dot"></button>
        <button className="top-dot"></button>
        <button className="top-dot"></button>
    </div>



    <div className="top-im">


    </div>
    <div className="top-details">
        <p className="top-card-title">shivaji</p>
        <p className="top-card-title1">legendary</p>
        <p className="top-card-title-price">$ 230  </p>

    </div>
    <div className="like">
        <span className="glyphicon glyphicon-heart-empty"> </span>
    </div>

</div>

<div className="explore-card">
    <button className="lo"></button>
    <button className="lo"></button>
    <button className="lo"></button>
    <div className="top-dot-menu">
        <button className="top-dot"></button>
        <button className="top-dot"></button>
        <button className="top-dot"></button>
    </div>



    <div className="top-im">


    </div>
    <div className="top-details">
        <p className="top-card-title">shivaji</p>
        <p className="top-card-title1">legendary</p>
        <p className="top-card-title-price">$ 230  </p>

    </div>
    <div className="like">
        <span className="glyphicon glyphicon-heart-empty"> </span>
    </div>

</div>

<div className="explore-card">
    <button className="lo"></button>
    <button className="lo"></button>
    <button className="lo"></button>
    <div className="top-dot-menu">
        <button className="top-dot"></button>
        <button className="top-dot"></button>
        <button className="top-dot"></button>
    </div>



    <div className="top-im">


    </div>
    <div className="top-details">
        <p className="top-card-title">shivaji</p>
        <p className="top-card-title1">legendary</p>
        <p className="top-card-title-price">$ 230  </p>

    </div>
    <div className="like">
        <span className="glyphicon glyphicon-heart-empty"> </span>
    </div>

</div>

<div className="explore-card">
    <button className="lo"></button>
    <button className="lo"></button>
    <button className="lo"></button>
    <div className="top-dot-menu">
        <button className="top-dot"></button>
        <button className="top-dot"></button>
        <button className="top-dot"></button>
    </div>



    <div className="top-im">


    </div>
    <div className="top-details">
        <p className="top-card-title">shivaji</p>
        <p className="top-card-title1">legendary</p>
        <p className="top-card-title-price">$ 230  </p>

    </div>
    <div className="like">
        <span className="glyphicon glyphicon-heart-empty"> </span>
    </div>

</div>

<div className="explore-card">
    <button className="lo"></button>
    <button className="lo"></button>
    <button className="lo"></button>
    <div className="top-dot-menu">
        <button className="top-dot"></button>
        <button className="top-dot"></button>
        <button className="top-dot"></button>
    </div>



    <div className="top-im">


    </div>
    <div className="top-details">
        <p className="top-card-title">shivaji</p>
        <p className="top-card-title1">legendary</p>
        <p className="top-card-title-price">$ 230  </p>

    </div>
    <div className="like">
        <span className="glyphicon glyphicon-heart-empty"> </span>
    </div>

</div>

<div className="explore-card">
    <button className="lo"></button>
    <button className="lo"></button>
    <button className="lo"></button>
    <div className="top-dot-menu">
        <button className="top-dot"></button>
        <button className="top-dot"></button>
        <button className="top-dot"></button>
    </div>



    <div className="top-im">


    </div>
    <div className="top-details">
        <p className="top-card-title">shivaji</p>
        <p className="top-card-title1">legendary</p>
        <p className="top-card-title-price">$ 230  </p>

    </div>
    <div className="like">
        <span className="glyphicon glyphicon-heart-empty"> </span>
    </div>

</div>

<div className="explore-card">
    <button className="lo"></button>
    <button className="lo"></button>
    <button className="lo"></button>
    <div className="top-dot-menu">
        <button className="top-dot"></button>
        <button className="top-dot"></button>
        <button className="top-dot"></button>
    </div>



    <div className="top-im">


    </div>
    <div className="top-details">
        <p className="top-card-title">shivaji</p>
        <p className="top-card-title1">legendary</p>
        <p className="top-card-title-price">$ 230  </p>

    </div>
    <div className="like">
        <span className="glyphicon glyphicon-heart-empty"> </span>
    </div>

</div>

<div className="explore-card">
    <button className="lo"></button>
    <button className="lo"></button>
    <button className="lo"></button>
    <div className="top-dot-menu">
        <button className="top-dot"></button>
        <button className="top-dot"></button>
        <button className="top-dot"></button>
    </div>



    <div className="top-im">


    </div>
    <div className="top-details">
        <p className="top-card-title">shivaji</p>
        <p className="top-card-title1">legendary</p>
        <p className="top-card-title-price">$ 230  </p>

    </div>
    <div className="like">
        <span className="glyphicon glyphicon-heart-empty"> </span>
    </div>


</div>

<div className="explore-card">
    <button className="lo"></button>
    <button className="lo"></button>
    <button className="lo"></button>
    <div className="top-dot-menu">
        <button className="top-dot"></button>
        <button className="top-dot"></button>
        <button className="top-dot"></button>
    </div>



    <div className="top-im">


    </div>
    <div className="top-details">
        <p className="top-card-title">shivaji</p>
        <p className="top-card-title1">legendary</p>
        <p className="top-card-title-price">$ 230  </p>

    </div>
    <div className="like">
        <span className="glyphicon glyphicon-heart-empty"> </span>
    </div>
</div>
</Carousel>;
</div>
</div>
        <Footer/>
        </div>
    )
}

export default Collections_sub
